import { HierarchyContextProps, IHierarchyActionSaveTocMajorVersion } from "../interface";

/**
 * Marks the current ToC as pending a major-version save.
 *
 * @param state - The current hierarchy context state.
 * @param action - The save-toc-major-version action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_saveTocMajorVersion = (
  state: HierarchyContextProps,
  action: IHierarchyActionSaveTocMajorVersion,
): HierarchyContextProps => ({
  ...state,
  doTocSave: true,
  saveTocDescription: action.saveTocDescription,
  hierarchyNodes: state.hierarchyNodes.filter((hn) => hn.id !== action.oldHierarchyId),
});
